import { render } from "./GrupoTelasView.vue?vue&type=template&id=7f77efc7"
import script from "./GrupoTelasView.vue?vue&type=script&lang=js"
export * from "./GrupoTelasView.vue?vue&type=script&lang=js"

import exportComponent from "C:\\GarantePay\\Desenvolvimento2026\\CodigoVue\\node_modules\\vue-loader\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__